import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=9583d4e6&scoped=true"
import script from "./Setup.vue?vue&type=script&setup=true&lang=ts"
export * from "./Setup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9583d4e6",
  null
  
)

export default component.exports